import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import qs from 'qs';
import router from '../router/router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    view: {
      isLoading: true,
      isLoadingProducts: false,
      isLoadingAttributes: false,
      type: ws_vue_store.config['product-grid'],
      sort: 'default',
      perPage: 50,
      perPageOptions: [10, 25, 50, 75, 100, 125],
      page: 1,
    },
    filters: {
      first: null,
      current: {},
      onSaleProducts: false,
      newProducts: false,
      priceSlider: {
        min: null,
        max: null,
      },
    },
    searchMode: false,
    productsHighestPrice: 0,
    productsCount: 0,
    searchProducts: [],
    featuredProducts: [],
    recentlyAddedProducts: [],
    products: [],
    // loadedTerms: [],
    attributeTaxonomies: [],
    filteredAttributeTaxonomies: [],
    allowedCategoryAttributes: [],
    showExcludedAttributes: true,
    attributesFirstLoadingState: true,
    categories: [],
    previouslyViewed: [],
  },
  getters: {
    getActiveFiltersCount: state => {
      return Object.keys(state.filters.current).length;
    },
    getSearchMode: state => {
      return state.searchMode;
    },
    getType: state => {
      return state.view.type;
    },
    getAttributeTaxonomy: state => key => {
      if (state.attributeTaxonomies.length === 0) {
        return null;
      }
      const foundAttributeTaxonomy = state.attributeTaxonomies.find(
        attributeTaxonomy => attributeTaxonomy.key === key
      );
      if (foundAttributeTaxonomy === undefined) {
        return null;
      }
      return foundAttributeTaxonomy;
    },
    getProducts: state => {
      return state.products;
    },
    getFilteredAttributeTaxonomies: (state, getters) => {
      const allowed_sidebar_filters = ws_vue_store.config['allowed_sidebar_filters'];

      if (ws_vue_store.disable_filters_relationship == 1) {
        state.filteredAttributeTaxonomies.map(attribute => {
          attribute.options.map(option => {
            option.excluded_filter = false;
          });
        });
      }

      if (Object.keys(state.filters.current).length == 0) {
        return state.filteredAttributeTaxonomies;
      }
      if (state.attributesFirstLoadingState) {
        state.attributesFirstLoadingState = false;
        return state.filteredAttributeTaxonomies;
      }
      if (allowed_sidebar_filters == undefined) return [];
      let allAttributes = state.attributeTaxonomies.filter(attr =>
        allowed_sidebar_filters.includes(attr.key)
      );

      if (ws_vue_store.disable_filters_relationship == 1) {
        return allAttributes;
      }

      state.filteredAttributeTaxonomies.map(attr => {
        let findAttributeIndex = allAttributes.findIndex(attribute => attribute.key == attr.key);
        if (findAttributeIndex != -1) {
          allAttributes[findAttributeIndex].options.map(option => {
            if (attr.options.find(opt => opt.slug == option.slug)) {
              option.excluded_filter = false;
            } else {
              option.excluded_filter = true;
            }
          });
        }
      });

      allAttributes.map(attribute => {
        let found = state.filteredAttributeTaxonomies.find(attr => attr.key == attribute.key);
        if (!found) {
          attribute.options.map(option => {
            option.excluded_filter = true;
          });
        }
      });

      return allAttributes;
    },
    getSearchedProducts: (state, getters) => {
      return state.searchProducts;
    },
    getFeaturedProducts: (state, getters) => {
      return state.featuredProducts;
    },
    getRecentlyAddedProducts: (state, getters) => {
      return state.recentlyAddedProducts;
    },
    getHighestPrice: (state, getters) => {
      return state.productsHighestPrice;
    },
    isDiscountedProductsPage(state, getters) {
      return state.filters.onSaleProducts;
    },
    isNewProductsPage(state, getters) {
      return state.filters.newProducts;
    },
    getAllowedAttributes(state, getters) {
      let allowedAttributes = ws_vue_store.config.allowed_attributes;
      if (
        state.allowedCategoryAttributes != undefined &&
        state.allowedCategoryAttributes.length > 0
      ) {
        return state.allowedCategoryAttributes;
      }
      return allowedAttributes;
    },
  },
  mutations: {
    changeLoadingState(state, newState) {
      state.view.isLoading = newState;
    },
    changeProductsLoadingState(state, newState) {
      state.view.isLoadingProducts = newState;
    },
    changeAttributesLoadingState(state, newState) {
      state.view.isLoadingAttributes = newState;
    },
    changeViewType(state, newType) {
      state.view.type = newType;
    },
    changePerPage(state, value) {
      state.view.perPage = parseInt(value, 10);
      if (router.currentRoute.query.ws_per_page !== parseInt(value, 10)) {
        router.push({ query: { ...router.currentRoute.query, ws_per_page: parseInt(value, 10) } });
      }
    },
    changeCurrentPage(state, newVal) {
      // Keep pagination on page refresh or from page link
      if (state.view.isLoading) {
        state.view.page = newVal;
        return;
      }
      if (state.products.length === 0 || newVal < 1) {
        state.view.page = 1;
      }
      if (state.products.length > newVal * state.view.perPage) {
        state.view.page = newVal;
      }
      if (router.currentRoute.query.ws_page !== parseInt(state.view.page, 10)) {
        router.push({
          query: {
            ...router.currentRoute.query,
            ws_page: parseInt(state.view.page, 10),
          },
        });
      }
    },
    changeShowExcludedAttributes(state, newVal) {
      state.showExcludedAttributes = newVal;
    },
    changeAttributesFirstLoadingState(state, newVal) {
      state.attributesFirstLoadingState = newVal;
    },
    setProductsHighestPrice(state, price) {
      state.productsHighestPrice = Math.ceil(price);
    },
    setProductsCount(state, count) {
      state.productsCount = count;
    },
    setSearchProducts(state, products) {
      state.searchProducts = products;
    },
    setFeaturedProducts(state, products) {
      state.featuredProducts = products;
    },
    setRecentlyAddedProduct(state, product) {
      state.recentlyAddedProducts.push(product);
    },
    setProducts(state, products) {
      state.products = products;
    },
    setFilteredAttributeTaxonomies(state, filteredAttributeTaxonomies) {
      const allowed_sidebar_filters = ws_vue_store.config['allowed_sidebar_filters'];
      if (allowed_sidebar_filters == undefined) return [];
      state.filteredAttributeTaxonomies = filteredAttributeTaxonomies.filter(attr =>
        allowed_sidebar_filters.includes(attr.key)
      );
    },
    setAttributeTaxonomies(state, attributeTaxonomies) {
      state.attributeTaxonomies = attributeTaxonomies;
    },

    setCategories(state, categories) {
      state.categories = categories;
    },

    updatePriceFilter(state, payload) {
      if (payload.type == 'min') {
        state.filters.priceSlider.min = payload.value;
      } else if (payload.type == 'max') {
        state.filters.priceSlider.max = payload.value;
      }
    },

    addFilter(state, payload) {
      if (payload.option === undefined || payload.taxonomy === undefined) {
        return;
      }

      if (payload.taxonomy == 'lang') {
        state.lang = payload.option;
        return;
      }

      if (state.filters.first === null) {
        state.filters.first = payload.taxonomy;
      }

      if (payload.taxonomy == 'keyword') {
        state.filters.keyword = payload.option;
        return;
      }

      if (payload.taxonomy == 'product_cat') {
        if (isNaN(payload.option)) return;
      }

      if (payload.taxonomy == 'on_sale_products') {
        state.filters.onSaleProducts = payload.option;
        return;
      }

      if (payload.taxonomy == 'is_new') {
        state.filters.newProducts = payload.option;
        return;
      }

      if (
        state.filters.current[payload.taxonomy] === undefined ||
        payload.taxonomy === 'product_cat'
      ) {
        state.filters.current = { ...state.filters.current, [payload.taxonomy]: [payload.option] };
        return;
      }
      state.filters.current = {
        ...state.filters.current,
        [payload.taxonomy]: [
          ...new Set([...state.filters.current[payload.taxonomy], payload.option]),
        ],
      };
    },
    removeFilter(state, payload) {
      if (
        payload.taxonomy === 'product_cat' &&
        state.filters.current[payload.taxonomy].length === 1
      ) {
        state.filters.current = {};
        state.filters.first = null;
      } else {
        state.filters.current = {
          ...state.filters.current,
          [payload.taxonomy]: state.filters.current[payload.taxonomy].filter(
            filter => filter !== payload.option
          ),
        };
      }

      if (
        state.filters.first === payload.taxonomy &&
        state.filters.current[state.filters.first].length === 0
      ) {
        state.filters.first = Object.keys(state.filters.current)[
          Object.keys(state.filters.current).findIndex(
            filterKey => state.filters.current[filterKey].length
          )
        ];
      }

      if (
        Object.keys(state.filters.current).every(
          filterKey => state.filters.current[filterKey].length === 0
        )
      ) {
        state.filters.first = null;
      }
    },
    clearFilters(state) {
      state.filters.current = {};
      state.filters.first = null;
      state.view.page = 1;
      state.showExcludedAttributes = true;

      // let firstCategory = state.categories.find(category => category.parent == 0 || category.parent < 1);
      // state.filters.current = { ...state.filters.current, 'product_cat': [firstCategory.term_id] };
      let mapped = {};
      if (typeof state.lang != undefined) {
        mapped['lang'] = state.lang;
      }
      router.push({ query: mapped });
    },

    setSort(state, selected) {
      state.view.sort = selected;
      if (router.currentRoute.query.ws_sort !== selected.code && selected.code !== 'default') {
        router.push({ query: { ...router.currentRoute.query, ws_sort: selected.code } });
      }
    },

    addProductToViewedList(state, product) {
      if (!product) {
        return;
      }
      if (state.previouslyViewed.length >= parseInt(ws_vue_store.previous_views_quantity, 10)) {
        state.previouslyViewed.splice(0, 1);
      }
      let productFound = state.previouslyViewed.find(p => p.id == product.id);

      if (!state.previouslyViewed.includes(product) && !productFound) {
        state.previouslyViewed = [product, ...state.previouslyViewed];
      }
    },

    changeSearchMode(state, newState) {
      state.searchMode = newState;
    },
    setCategoryAllowedAttributes(state, newState) {
      state.allowedCategoryAttributes = newState;
    },
  },
  actions: {
    async searchProducts({ commit, state }, payload) {
      if (typeof payload.keyword == undefined) return;

      let postData = {
        filters: {
          keyword: payload.keyword,
          languageCode: ws_vue_store.language_code,
          keyword_extra_fields: ws_vue_store.search_additional_fields,
        },
        pageLimit: 5,
      };
      postData['include_meta_fields'] = true;
      let metaFields = ['_directo_product_closed'];
      postData['meta_fields'] = metaFields;

      // `ws-wc-role-discounts` plugin data
      if (ws_vue_store.discount_rules) {
        postData['filters']['discountRules'] = ws_vue_store.discount_rules;
      }

      if (ws_vue_store.attribute_custom_order == '1') {
        postData['attr_custom_order'] = true;
      }

      if (ws_vue_store.new_product_categories) {
        postData['new_cate'] = ws_vue_store.new_product_categories;
      }

      try {
        const result = await axios.post(ws_vue_store.products_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          commit('setSearchProducts', result.data.list);
        }
      } catch (error) {
        console.error('Request error:', error);
      }
    },
    async getProducts({ commit, state }) {
      let postData = {
        filters: {
          ...state.filters.current,
          keyword: state.filters.keyword != undefined ? state.filters.keyword : null,
          priceSlider: state.filters.priceSlider,
          languageCode: ws_vue_store.language_code,
          keyword_extra_fields: ws_vue_store.search_additional_fields,
        },
        custom_price: {},
        product_custom_fields: {},
        sort: state.view.sort.code,
        pageIndex: state.view.page - 1,
        pageLimit: state.view.perPage,
      };
      postData['include_meta_fields'] = true;
      let metaFields = ['_directo_product_closed'];
      postData['meta_fields'] = metaFields;

      if (ws_vue_store.new_product_categories) {
        postData['new_cate'] = ws_vue_store.new_product_categories;
      }

      if (ws_vue_store.attribute_custom_order == '1') {
        postData['attr_custom_order'] = true;
      }

      if (state.filters.onSaleProducts != undefined && state.filters.onSaleProducts) {
        postData['filters']['on_sale_products'] = state.filters.onSaleProducts;
      }

      if (state.filters.newProducts != undefined && state.filters.newProducts) {
        postData['filters']['is_new'] = state.filters.newProducts;
      }

      // `ws-wc-role-discounts` plugin data
      if (ws_vue_store.discount_rules) {
        postData['filters']['discountRules'] = ws_vue_store.discount_rules;
      }

      if (ws_vue_store.config['product-grid'] == 'wells') {
        let allowedAttributes = ws_vue_store.config.allowed_attributes;
        if (
          state.allowedCategoryAttributes != undefined &&
          state.allowedCategoryAttributes.length > 0
        ) {
          allowedAttributes = state.allowedCategoryAttributes;
        }
        postData['include_meta_fields'] = true;

        if (allowedAttributes.length > 0) {
          let metaFields = allowedAttributes.map(function(attribute, index) {
            return 'attribute_' + attribute;
          });
          postData['meta_fields'] = metaFields;
        }
      }

      // Company and project discount - (hekamerk)
      if (ws_vue_store.company_id) {
        postData['custom_price']['company_id'] = ws_vue_store.company_id;
      }
      if (ws_vue_store.project_searchcode) {
        postData['custom_price']['project_searchcode'] = ws_vue_store.project_searchcode;
      }

      if (ws_vue_store.show_measurement_unit == '1') {
        postData['product_custom_fields'].measurement_unit = 'string';
      }

      if (ws_vue_store.enable_buying_step == '1') {
        postData['product_custom_fields'].buying_step = 'float';
      }

      try {
        const result = await axios.post(ws_vue_store.products_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          commit('setProductsCount', result.data.total);
          commit('setProducts', result.data.list);
          commit('changeLoadingState', false);
          commit('changeProductsLoadingState', false);
        } else {
          // TODO: show something to user or just loading screen will be shown to user
        }
      } catch (error) {
        console.error('Request error:', error);
        // TODO: endpoint is messed up
      }
    },
    async getAttributes({ commit, state }) {
      try {
        const url = ws_vue_store.attributes_endpoint + ws_vue_store.language_code;
        const result = await axios.get(url);

        if (result && result.data && result.data.state == 'OK') {
        }
      } catch (error) {
        console.error('Request error:', error);
        // TODO: endpoint is messed up
      }
    },
    async getFilteredAttributes({ commit, state }) {
      let postData = {
        filters: {
          ...state.filters.current,
          priceSlider: state.filters.priceSlider,
          languageCode: ws_vue_store.language_code,
        },
        show_excluded: state.showExcludedAttributes,
      };

      if (ws_vue_store.attribute_custom_order == '1') {
        postData['custom_order'] = true;
      }

      try {
        const result = await axios.post(ws_vue_store.filtered_attributes_endpoint, postData);

        if (result && result.data && result.data.state == 'OK') {
          if (state.showExcludedAttributes) {
            commit('setAttributeTaxonomies', result.data.data.attributes);
            commit('changeShowExcludedAttributes', false);
            commit('changeAttributesFirstLoadingState', true);
          }
          commit('setProductsHighestPrice', result.data.data.max_price);
          commit('setFilteredAttributeTaxonomies', result.data.data.attributes);
        }
      } catch (error) {
        console.error('Request error:', error);
        // TODO: endpoint is messed up
      }
    },
    async addFilter({ dispatch, commit, state }, payload) {
      commit('changeProductsLoadingState', true);
      let isCategory = false;
      if (payload.taxonomy === 'product_cat') {
        commit('changeCurrentPage', 1);
        commit('changeShowExcludedAttributes', true);
        commit('updatePriceFilter', { value: null, type: 'min' });
        commit('updatePriceFilter', { value: null, type: 'max' });
        state.filters.current = { product_cat: [payload.option] };
        isCategory = true;
      }

      commit('addFilter', payload);

      const mapped = {};
      Object.keys(state.filters.current).forEach(key => {
        mapped[`ws_${key}`] = state.filters.current[key];
      });

      if (typeof state.filters.keyword != undefined) {
        mapped['search_term'] = state.filters.keyword;
      }
      console.log(state.filters);
      if (isCategory) {
        delete state.filters.keyword;
        delete mapped['search_term'];
      }

      if (typeof state.lang != undefined) {
        mapped['lang'] = state.lang;
      }

      if (typeof state.filters.onSaleProducts != undefined && state.filters.onSaleProducts) {
        mapped['on_sale_products'] = state.filters.onSaleProducts;
      }

      if (typeof state.filters.newProducts != undefined && state.filters.newProducts) {
        mapped['is_new'] = state.filters.newProducts;
      }

      router.push({ query: mapped });

      dispatch('getFilteredAttributes', []).then(() => dispatch('getProducts', []));
    },
    removeFilter({ dispatch, commit, state }, payload) {
      commit('changeProductsLoadingState', true);
      commit('removeFilter', payload);

      const mapped = {};
      Object.keys(state.filters.current).forEach(key => {
        mapped[`ws_${key}`] = state.filters.current[key];
      });
      router.push({ query: mapped });

      dispatch('getFilteredAttributes', []).then(() => dispatch('getProducts', []));
    },
  },
  modules: {},
});
